const deleteEmptyKeysAndValues = (obj: any): any => {
    const result: any = JSON.parse(JSON.stringify(obj));

    function recursiveFce(target: any): void {
        for (const prop in target) {
            if (target.hasOwnProperty(prop)) {
                if (typeof target[prop] === 'object') {
                    // Recursively call the function for nested objects
                    recursiveFce(target[prop]);

                    // If the nested object is now empty, delete it
                    // if (Object.keys(target[prop]).length === 0) {
                    //     delete target[prop];
                    // }
                } else if (target[prop] === null || target[prop] === undefined || target[prop] === '') {
                    // Delete properties with null, undefined, or empty string values
                    delete target[prop];
                }
            }
        }
    }

    recursiveFce(result);

    return result;
};
export default deleteEmptyKeysAndValues;
